var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "jade-badge", class: _vm.computedClassName },
    [
      _vm.displayText
        ? _c(
            "span",
            { staticClass: "jade-badge__label-wrapper" },
            [
              _c(
                "JadeText",
                {
                  attrs: {
                    variant: "text-small",
                    weight: "semibold",
                    color: "current-color",
                  },
                },
                [_vm._t("default")],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }